import classNames from 'classnames';
import { FC, HTMLAttributes, PropsWithChildren } from 'react';

import css from './FormRow.module.scss';

interface Props extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  isHidden?: boolean;
}

const FormRow: FC<PropsWithChildren<Props>> = ({ className, children, isHidden = false, ...rest }) => {
  return (
    <div
      className={classNames(
        'form__row',
        css.row,
        {
          [css.row_hidden]: isHidden,
        },
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
};

export default FormRow;
